import { ThemeOptions } from '@material-ui/core/styles/createMuiTheme'

const options: ThemeOptions = {}
export default options
